import React from 'react';

export const EmptyCell: React.FC = () => {
  return <div style={{ height: 40, width: 2 }} />;
};
